import { Button, CircularProgressBar, Typography } from "@kyan/ui";
import { type FC, useEffect, useState } from "react";

interface CountdownButtonProps {
  seconds: number;
  onClick?: () => void;
}

export const CountdownButton: FC<CountdownButtonProps> = ({
  seconds,
  onClick,
}) => {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const isActive = timeLeft > 0;
  const remainingPercentage = (timeLeft / seconds) * 100;

  useEffect(() => {
    setTimeLeft(seconds);

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  const handleClick = () => {
    setTimeLeft(0);

    onClick?.();
  };

  return (
    <Button
      size="lg"
      disabled={!isActive}
      className="flex w-full gap-2 text-[15px] shadow-none"
      onClick={handleClick}
    >
      <Typography>{`${timeLeft} sec to confirm`}</Typography>
      <CircularProgressBar
        size={14}
        strokeWidth={2}
        value={remainingPercentage}
      />
    </Button>
  );
};
